module.exports = "https://store.zigzag.kr/resources/arm64/20260309-1626-02155f9b4a_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";